import { createSlice } from "@reduxjs/toolkit";
import { customerContactApi } from "../../../Service/customerContact";
import { customerMedicalApi } from "../../../Service/customerMedical";
import { api } from "../../../Service/customers";
import { GetCustomerContact, GetCustomerDetail, GetcustomerLogs } from "../../async-actions/digitalmarketing/customer";
import { CustomerLog, CustomerLogApi } from "../../../Service/CustomerLogs";
import { CustomerAppointmentApi } from "../../../Service/CustomerAppointment";
import { CustomerJourneyApi } from "../../../Service/CustomerJourney";
import { CustomerReminderApi } from "../../../Service/CustomerReminder";
import { CustomerBloodAppointmentApi } from "../../../Service/CustomerBloodAppointment";

const initialState = {
  customerLogs: [],
  customerMedical: {
    id: null,
    customerId: null,
    ivf: 0,
    ivfYear: null,
    ivfMonth: null,
    iui: 0,
    iuiYear: null,
    iuiMonth: null,
    icsi: 0,
    icsiYear: null,
    icsiMonth: null,
    miscarriages: 0,
    miscarriagesYear: null,
    miscarriagesMonth: null,
    children: 0,
    childrenONE: null,
    childrenTWO: null,
    childrenTHREE: null,
    lmp: "",
    healthIssues: "",
    spouseHealthIssues: "",
    occupation: "",
    spouseOccupation: "",
    areaOfInterest: "",
    status: null
  },
  customerPeriod: {
    id: null,
    userId: null,
    mensturalCycle: "",
    avg_periodCength: "",
    cycleLength: null,
    lastPeriod: null,
    ovulationDate: null,
    idea_about_cycle: "",
    periodFlow: "",
    ideaAboutCycle: "",


  },
  customerContact: {
    id: null,
    customerId: "",
    phone1: '',
    phone2: '',
    email1: "",
    email2: "",
    city: "",
    area: "",
    status: null
  },
  cycleIqDetails:{
    id: null,
    customerId: "",
    bmi:'',
    amh_ng_ml:'',
    afc:'',
    comorbidities:[],
    otherMedications:''
  },
  customerDetail: {
    id: null,
    customerName: "",
    age: 0,
    sex: "",
    spouseName: "",
    spouseAge: 0,
    spouseSex: "",
    yearsMarried: "",
    source: "",
    status: false,
    customerStatus: "",
    serviceChoosen: "",
    referredBy: "",
    occupation: ""
  },
  whatsappsetting: {
    apiKey: "",
    appName: "",
    channel: "whatsapp",
    sourceMobileNumber: ""
  },
  facebooksetting: {
    userAccountId: "",
    campaignId: "",
    accessToken: "",
  },
  templatesetting: {
    id: "",
    templateName: "",
    templateBody: "",
    templateId: "",

  },
  customerAppointment: {
    id: null,
    customerId: null,
    appointmentDate: null,
    appointmentTime: null,
  },
  customerBloodAppointment: {
    id: null,
    customerId: null,
    bloodTestDate: null,
    bloodTestTime: null,
  },
  customerJourney: [],
  customerReminder: {
    id: null,
    customerId: null,
    userId: null,
    reminderTo: "",
    reminderFor: "",
    reminderOnce: "",
    mediums: "",
    status: "",
    comments: ""
  },
  customerReminderHistory: [],

};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    updateCustomerDetail: (state, action) => {
      state.customerDetail = { ...state.customerDetail, ...action.payload }
    },
    updatewhatsappsetting: (state, action) => {
      state.whatsappsetting = { ...state.whatsappsetting, ...action.payload }
      // console.log(state.whatsappsetting);

    },
    updatefacebooksetting: (state, action) => {
      state.facebooksetting = { ...state.facebooksetting, ...action.payload }
      // console.log(state.facebooksetting);

    },
    updateperiod: (state, action) => {
      state.customerPeriod = { ...state.customerPeriod, ...action.payload }
      console.log(state.customerPeriod);

    },
    updatetemplatesetting: (state, action) => {
      state.templatesetting = { ...state.templatesetting, ...action.payload }
      // console.log(state.templatesetting);

    },
    updateCustomerContactDetail: (state, action) => {
      state.customerContact = { ...state.customerContact, ...action.payload }
    },
     updateCycleIQDetail: (state, action) => {
      state.cycleIqDetails = { ...state.cycleIqDetails, ...action.payload }
    },
    updateCustomerMedicalDetail: (state, action) => {
      state.customerMedical = { ...state.customerMedical, ...action.payload }
    },
    updateCustomerAppointmentDetail: (state, action) => {
      state.customerAppointment = { ...state.customerAppointment, ...action.payload }
    },
    updateCustomerBloodAppointmentDetail: (state, action) => {
      state.customerBloodAppointment = { ...state.customerBloodAppointment, ...action.payload }
    },
    updateCustomerJourneyDetail: (state, action) => {
      state.customerJourney = [...state.customerJourney, action.payload]
    },
    updateCustomerReminderDetail: (state, action) => {
      // console.log(action.payload);

      state.customerReminder = { ...state.customerReminder, ...action.payload }
    },
    resetReducer: () => initialState
  },
  // extraReducers: {

  //   [GetcustomerLogs.fulfilled.type]: (state, action) => {
  //     state.customerLogs = action.payload;
  //   },
  //   [GetCustomerContact.fulfilled.type]: (state, action) => {
  //     console.log(action.payload.data.response);
  //     state.customerContact = action.payload.data.data;
  //   },
  //   [GetCustomerDetail.fulfilled.type]: (state, action) => {
  //     console.log(action.payload.data.response);
  //     state.customerDetail = action.payload.data.data;
  //   },
  // },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.getCustomer.matchFulfilled, (state, action) => {
      // pretend this field and this payload data exist for sake of example
      state.customerDetail = { ...state.customerDetail, ...action.payload }
    })
      .addMatcher(customerContactApi.endpoints.getCustomerContact.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        state.customerContact = data
      })
      .addMatcher(customerMedicalApi.endpoints.getCustomerPeriodTracker.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        console.log(data);

        state.customerPeriod = data
      })
      .addMatcher(customerMedicalApi.endpoints.getCustomerMedical.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        state.customerMedical = { ...state.customerMedical, ...data }
      })
      .addMatcher(api.endpoints.addCustomer.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.customerDetail = { ...state.customerDetail, ...action.payload }
      })
      .addMatcher(customerContactApi.endpoints.addCustomerContact.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.customerContact = { ...state.customerContact, ...action.payload }
      })
      .addMatcher(customerMedicalApi.endpoints.addCustomerMedical.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.customerMedical = { ...state.customerMedical, ...action.payload }
      })
       .addMatcher(customerMedicalApi.endpoints.addCycleIq.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.cycleIqDetails = { ...state.cycleIqDetails, ...action.payload }
      })
       .addMatcher(customerMedicalApi.endpoints.getCustomerCycleIQ.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        state.cycleIqDetails = { ...state.cycleIqDetails, ...data }
      })
      .addMatcher(CustomerLogApi.endpoints.getCustomerLogByCustomerId.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.customerLogs = action.payload
      })
      .addMatcher(CustomerLogApi.endpoints.addCustomerLog.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.customerLogs = [...state.customerLogs, action.payload]
      })
      .addMatcher(CustomerAppointmentApi.endpoints.addCustomerAppointment.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        state.customerAppointment = { ...state.customerAppointment, ...data }
      })
      .addMatcher(CustomerAppointmentApi.endpoints.getCustomerAppointmentByCustomerId.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        state.customerAppointment = { ...state.customerAppointment, ...data }
      })
      .addMatcher(CustomerBloodAppointmentApi.endpoints.addCustomerBloodAppointment.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        state.customerAppointment = { ...state.customerAppointment, ...data }
      })
      .addMatcher(CustomerBloodAppointmentApi.endpoints.getCustomerBloodAppointmentByCustomerId.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        state.customerAppointment = { ...state.customerAppointment, ...data }
      })
      .addMatcher(CustomerJourneyApi.endpoints.getCustomerJourneyByCustomerId.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.customerJourney = action.payload
      })
      .addMatcher(CustomerJourneyApi.endpoints.addCustomerJourney.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        state.customerJourney = [...state.customerJourney, action.payload]
      })
      .addMatcher(CustomerReminderApi.endpoints.addCustomerReminder.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action.payload[0] || action.payload
        // console.log(action.payload,state.customerAppointment);

        state.customerReminder = { ...state.customerAppointment, ...data }
      })
      .addMatcher(CustomerReminderApi.endpoints.getCustomerReminderByCustomerId.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example
        let data = action?.payload[0] || action?.payload
        // console.log(action?.payload,state?.customerAppointment);
        state.customerReminder = { ...state?.customerAppointment, ...data }
      })
      .addMatcher(CustomerReminderApi.endpoints.getCustomerReminderHistory.matchFulfilled, (state, action) => {
        // pretend this field and this payload data exist for sake of example        
        let data = action.payload[0] || action.payload
        // console.log(action.payload,state.customerAppointment);
        state.customerReminderHistory = { ...state.customerAppointment, ...data }
      })
  }
});
export default customerSlice.reducer;

export const { updateCustomerDetail, updateperiod, updatewhatsappsetting, updatefacebooksetting, updatetemplatesetting, resetReducer, updateCustomerContactDetail,updateCycleIQDetail, updateCustomerMedicalDetail, updateCustomerAppointmentDetail, updateCustomerBloodAppointmentDetail, updateCustomerReminderDetail } = customerSlice.actions

